import { IsOptional, IsPositive, Min } from "class-validator";
import { Transform } from "class-transformer";

export class QueryDto {
  @IsOptional()
  name?: string;

  @IsOptional()
  @IsPositive()
  limit?: number = 5;

  @IsOptional()
  @Min(0)
  offset?: number = 0;

  @IsOptional()
  orderBy?: string;

  @IsOptional()
  owner?: string;

  constructor(query: Partial<QueryDto> = {}) {
    this.name = query.name;
    this.limit = query.limit;
    this.offset = query.offset;
    this.orderBy = query.orderBy;
    this.owner = query.owner;
  }

  static nestedParamDecoder(param: string): Object {
    if (param) {
      const paramPairs = param.split(',');
      const paramObject = {};
      paramPairs.forEach(pair => {
        const [ key, val ] = pair.split('-');
        paramObject[key] = val;
      })
      return paramObject;
    } else {
      return null;
    }
  }
}
export class HoundQueryDto extends QueryDto {
  @IsOptional()
  sex?: number;

  @IsOptional()
  @Transform(running => running.obj.running === 'true' ? true : false)
  running?: boolean;

  @IsOptional()
  @Transform(availableToBreed => availableToBreed.obj.availableToBreed === 'true' ? true : false)
  availableToBreed?: boolean;

  @IsOptional()
  @Transform(hasLibido => hasLibido.obj.hasLibido === 'true' ? true : false)
  hasLibido?: boolean;

  @IsOptional()
  minRuns?: number;

  @IsOptional()
  minFee?: string;

  @IsOptional()
  maxFee?: string;

  @IsOptional()
  minTokenId?: number;

  @IsOptional()
  maxTokenId?: number;

  @IsOptional()
  minStamina?: number;

  constructor(query: Partial<HoundQueryDto> = {}) {
    super(query);
    this.sex = query.sex;
    this.running = query.running;
    this.availableToBreed = query.availableToBreed;
    this.hasLibido = query.hasLibido;
    this.minRuns = query.minRuns;
    this.minFee = query.minFee;
    this.maxFee = query.maxFee;
    this.minStamina = query.minStamina;
  }
}

export class ArenaQueryDto extends QueryDto {
  constructor(query: Partial<ArenaQueryDto> = {}) {
    super(query);
  }
}


export class RaceQueryDto extends QueryDto {
  @IsOptional()
  maxTicketPrice?: number;

  @IsOptional()
  minTicketPrice?: number;

  @IsOptional()
  surfaceType?: number;

  @IsOptional()
  distanceType?: number;

  @IsOptional()
  weatherType?: number;

  @IsOptional()
  arenaType?: string;

  @IsOptional()
  totalParticipants?: number;

  constructor(query: Partial<RaceQueryDto> = {}) {
    super(query);
    this.maxTicketPrice = query.maxTicketPrice;
  }
}

export class QueueQueryDto extends QueryDto {
  @IsOptional()
  @Transform(isUpcoming => isUpcoming.obj.isUpcoming === 'true' ? true : false)
  isUpcoming?: Boolean;

  @IsOptional()
  maxTicketPrice?: number;

  @IsOptional()
  minTicketPrice?: number;

  @IsOptional()
  @Transform(closed => closed.obj.closed === 'true' ? true : false)
  closed?: boolean;

  @IsOptional()
  surfaceType?: number;

  @IsOptional()
  distanceType?: number;

  @IsOptional()
  weatherType?: number;

  @IsOptional()
  arenaType?: string;

  @IsOptional()
  totalParticipants?: number;

  @IsOptional()
  @Transform(isAvailable => isAvailable.obj.isAvailable === 'true' ? true : false)
  isAvailable?: boolean;

  constructor(query: Partial<QueueQueryDto> = {}) {
    super(query);
    this.maxTicketPrice = query.maxTicketPrice;
    this.isUpcoming = query.isUpcoming;
  }
}
